import { getLocationListApi, getLocationsApi } from 'SupabseHandler';
import {
    businessData as businessDataAtom,
    locationData as locationDataAtom,
    locationDataList,
    locationList as locationListAtom,
    selectedLocation as selectedLocationAtom,
} from 'atoms';
import AddLocationPopup from 'pages/Business/Location/AddLocationPopup';
import EmptyOfficeLocations from 'pages/Business/Location/EmptyOfficeLocations';
import LocationTable from 'pages/Business/Location/LocationTable';
import InnerPageLayout from 'pages/Business/Partials/InnerPageLayout';
import { useRecoilState } from 'recoil';
import styled from 'styled-components';
import { isObjectEmpty } from 'utils/methods';
import { useAuth } from 'context/AuthContext';

import React, { useEffect, useState, useRef } from 'react';

const DataContainer = styled.div`
    background: ${(props) => props.theme.colorBackground};
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    flexgrow: 1;
`;

const LocationHome = () => {
    const { token, loading: authLoading } = useAuth();
    const [business, setBusiness] = useRecoilState(businessDataAtom);
    const [locationList, setLocationList] = useRecoilState(locationListAtom);
    const [selectedLocation, setSelectedLocation] = useRecoilState(selectedLocationAtom);
    const [formData, setFormData] = useRecoilState(locationDataAtom);
    const [editLocation, setEditLocation] = useRecoilState(locationDataList);
    const [rows, setRows] = useState([]);
    const [openPopup, setOpenPopup] = useState(false);
    const [loadingData, setLoadingData] = useState(false);
    const prevOpenPopupRef = useRef(false);

    // Clear form data and selected location on component mount
    useEffect(() => {
        setFormData({
            location_name: '',
            location_phone_no: '',
            location_address: '',
            street: '',
            city: '',
            state: '',
            zipCode: '',
            form_status: 'add',
        });
        setSelectedLocation({});
        setEditLocation([]);
    }, []);

    const getLocations = async (id) => {
        try {
            if (!token) {
                console.error('No authentication token found');
                setSelectedLocation({ error: 'No authentication token found' });
                return;
            }
            const data = await getLocationsApi(id, token);
            setSelectedLocation(data);
            setEditLocation([{
                location_name: data?.name,
                location_phone_no: data?.phone,
                location_address: data?.address,
                suite: data?.suite,
                city: data?.city,
                state: data?.state,
                zipCode: data?.zip,
            }])
        } catch (err) {
            console.error('Error fetching location:', err);
            setSelectedLocation({ error: err.message });
        }
    };

    const getLocationList = async () => {
        try {
            if (authLoading) {
                return; // Wait for auth to finish loading
            }
            if (!token) {
                console.error('No authentication token found');
                setLocationList([]);
                return;
            }
            const data = await getLocationListApi(business?.id, token);
            // Ensure data is always an array
            setLocationList(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error('Error fetching location list:', err);
            // Always set to an array, even on error
            setLocationList([]);
        }
    };

    useEffect(() => {
        if (selectedLocation && !isObjectEmpty(selectedLocation)) {
            setFormData({
                location_name: selectedLocation?.name,
                location_phone_no: selectedLocation?.phone,
                location_address: selectedLocation?.address,
                city: selectedLocation?.city,
                state: selectedLocation?.state,
                zipCode: selectedLocation?.zip,
                suite: selectedLocation?.suite,
                form_status: 'edit',
            });
            setLoadingData(false);
        }

        // Ensure locationList is an array before mapping
        if (Array.isArray(locationList) && locationList.length > 0) {
            let rows = locationList.map((location) => {
                return {
                    id: location.id,
                    nickName: location.name,
                    phoneNumber: location.phone,
                    address: location.address,
                    city: location.city,
                    state: location.state,
                    zip: location.zip,
                };
            });
            setRows(rows);
        } else {
            setRows([]);
        }

    }, [selectedLocation, locationList]);

    useEffect(() => {
        if (business?.id && !authLoading && token) {
            getLocationList();
        }
    }, [business?.id, authLoading, token]);

    // Refresh location list when popup closes (but not on initial mount)
    useEffect(() => {
        // Only refresh if popup was previously open and is now closed
        if (prevOpenPopupRef.current === true && openPopup === false && business?.id && !authLoading && token) {
            getLocationList();
        }
        // Update the ref to track current state for next render
        prevOpenPopupRef.current = openPopup;
    }, [openPopup, business?.id, authLoading, token]);
    
    const togglePopup = (e) => {
        if (e?.row) {
            setLoadingData(true);
            getLocations(e.row.id).then((data) => {});
        } else {
            setFormData({
                location_name: '',
                location_phone_no: '',
                location_address: '',
                street: '',
                city: '',
                state: '',
                zipCode: '',
                form_status: 'add',
            });
            setSelectedLocation({});
            setEditLocation([]);
            setLoadingData(false);
        }

        setOpenPopup(!openPopup);
    };
    const isBuisnessAdded = business?.email?.length > 0;
    
    // const isBuisnessAdded = business?.business_url?.length > 0 && business?.email?.length>0 && business?.website_url?.length>0;
    return (
        <>
            {business?.id !== undefined  && isBuisnessAdded && (
                <DataContainer>
                    {!Array.isArray(locationList) || locationList.length === 0 ? (
                        <EmptyOfficeLocations togglePopup={togglePopup} />
                    ) : (
                        <InnerPageLayout 
                            heading="Office Locations" 
                            togglePopup={togglePopup} 
                            btnText="Add a Location"
                            buttonType="secondary"
                        >
                            <LocationTable rows={rows} togglePopup={togglePopup}></LocationTable>
                        </InnerPageLayout>
                    )}
                </DataContainer>
            )}

            {!loadingData && <AddLocationPopup open={openPopup} onClose={togglePopup}></AddLocationPopup>}
        </>
    );
};

export default LocationHome;
